import Vue from 'vue';

/**
 * Line Liff 初始化
 * 不需要 @param 
 */
export const lineLiffInit = function() {
  // 帶入 liff 的 function;
  const liff = window.liff;
  const loginChannelId = process.env.VUE_APP_LINE_LOGIN_CHANNEL_ID;
  const liffId = process.env.VUE_APP_LINE_LIFF_ID;
  const lineAddFriendUrl = process.env.VUE_APP_LINE_ADD_FRIEND_URL;
  const localUrl = process.env.VUE_APP_LOCAL_URL;
  // 登入後要倒到哪裡
  const redirectUri = process.env.VUE_APP_FUBON_DOMAIN_URL;
  return new Promise((resolve) => {
    liff.init({
        liffId: `${loginChannelId}-${liffId}` // use own liffId
    })
    .then(async() => {
      //- 1.檢查是否有 Login In，沒有就導至 LINE Login In 頁面
      const isLoggedIn = await liff.isLoggedIn();
      // 如果還沒登入就登入
      if(!isLoggedIn) {
        liff.login({
          redirectUri: window.location.href
        });
        let result = {
          pass: false,
          target: 'login'
        }
        //- 直接結束
        resolve(result);
        return;
      }
      //- 2.檢查是否已有加入好友，沒有就導至加入好友
      const isFriend = await liff.getFriendship();
      // 如果沒有就導至加好友頁面
      if(!isFriend.friendFlag) {
        window.location = lineAddFriendUrl;
        let result = {
          pass: false,
          target: 'lineAddFriend'
        }
        //- 直接結束
        resolve(result);
        return;
      }
      //- 3. 取得 accessToken
      const accessToken = await liff.getAccessToken();

      //- 4. 取得一些資訊
      // -> 確認手機裝置
      const device = await liff.getOS();
      // -> 確認是否在 APP 內開啟
      const inLineAPP = await liff.isInClient();

      //- 4. 取得個人資料
      const profileInfo = await liff.getProfile();
      Vue.prototype.$line_uuid = profileInfo.userId;
      //- 5. 整理資料
      let result = {
        pass: true,
        device: device,
        inLineAPP: inLineAPP,
        isLoggedIn: isLoggedIn,
        isFriend: isFriend.friendFlag ? true : false,
        accessToken: accessToken,
        profileInfo: profileInfo
      }
      //- 回傳
      resolve(result);
    }).catch(error => {
      console.error(error);
    })
  })
}